

export default function MultiCityIntResult() {
  return (
    <>
      <div class="result_repeat">
        <div class="row">
          <div class="col-md-8 col-lg-8">
            <div class="row multi_city">
              <div class="col-md-4 col-lg-4">
                <div class="row">
                  <div class="col-md-4 col-lg-4">
                    <div class="flight_img"><img class="img_icon" src="/assets/images/flight/flight_v.png" /></div>
                  </div>
                  <div class="col-md-8 col-lg-8">
                    <figure class="flight_sect">
                      <span>IX - 1194</span><span class="airlineImage">Air India Express</span><span class="onTime"><i class="fa fa-clock"></i> 90% On-Time</span>
                    </figure>
                  </div>
                </div>
              </div>
              <div class="col-md-8 col-lg-8 border-left-right">
                <div class="row">
                  <div class="col-md-4 col-lg-4">
                    <div class="timer">
                      <h4>16:55</h4>
                      <p>Delhi</p>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div class="deruation">
                      <p>06h 05m</p>
                      <div class="bordr_top"><i class="fa fa-plane"></i></div>
                      <p class="stops">1 stop</p>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-4 offset-1">
                    <div class="timer">
                      <h4>23:00</h4>
                      <p>Dubai</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row multi_city">
              <div class="col-md-4 col-lg-4">
                <div class="row">
                  <div class="col-md-4 col-lg-4">
                    <div class="flight_img"><img class="img_icon" src="/assets/images/flight/flight_v.png" /></div>
                  </div>
                  <div class="col-md-8 col-lg-8">
                    <figure class="flight_sect">
                      <span>IX - 1194</span><span class="airlineImage">Air India Express</span><span class="onTime"><i class="fa fa-clock"></i> 90% On-Time</span>
                    </figure>
                  </div>
                </div>
              </div>
              <div class="col-md-8 col-lg-8 border-left-right">
                <div class="row">
                  <div class="col-md-4 col-lg-4">
                    <div class="timer">
                      <h4>16:55</h4>
                      <p>Dubai</p>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div class="deruation">
                      <p>06h 05m</p>
                      <div class="bordr_top"><i class="fa fa-plane"></i></div>
                      <p class="stops">1 stop</p>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-4 offset-1">
                    <div class="timer">
                      <h4>23:00</h4>
                      <p>Mumbai</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row multi_city">
              <div class="col-md-4 col-lg-4">
                <div class="row">
                  <div class="col-md-4 col-lg-4">
                    <div class="flight_img"><img class="img_icon" src="/assets/images/flight/flight_v.png" /></div>
                  </div>
                  <div class="col-md-8 col-lg-8">
                    <figure class="flight_sect">
                      <span>IX - 1194</span><span class="airlineImage">Air India Express</span><span class="onTime"><i class="fa fa-clock"></i> 90% On-Time</span>
                    </figure>
                  </div>
                </div>
              </div>
              <div class="col-md-8 col-lg-8 border-left-right">
                <div class="row">
                  <div class="col-md-4 col-lg-4">
                    <div class="timer">
                      <h4>16:55</h4>
                      <p>Mumbai</p>
                    </div>
                  </div>
                  <div class="col-md-3 col-lg-3">
                    <div class="deruation">
                      <p>06h 05m</p>
                      <div class="bordr_top"><i class="fa fa-plane"></i></div>
                      <p class="stops">1 stop</p>
                    </div>
                  </div>
                  <div class="col-md-4 col-lg-4 offset-1">
                    <div class="timer">
                      <h4>23:00</h4>
                      <p>Delhi</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4">
            <div class="price_view">
              <div class="row">
                <div class="col-md-7 col-lg-7">
                  <div class="flight_charge"><i class="fa fa-inr"></i> 899739</div>
                  <a class="view_more" data-bs-toggle="offcanvas" data-bs-target="#ViewMoreFare">View More Fare <i class="fa fa-arrow-right"></i> </a>
                </div>
                <div class="col-md-5 col-lg-5"><a href="/Flight/booking" class="book_now">Book Now</a><a href="/Flight/booking" class="Send_Request">Send Request</a></div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12">
            <ul class="list_service">
              <li><i class="fa-solid fa-fan"></i><span>b777-69(er)</span></li>
              <li><img class="seats" src="/assets/images/seat.png" /><span>Narrow</span></li>
              <li><img class="seats" src="/assets/images/seat.png" /><span>Narrow(Limited tilt)</span></li>
              <li><i class="fa fa-wifi"></i></li>
              <li><i class="fa-solid fa-plug"></i></li>
              <li><i class="fa-brands fa-youtube"></i></li>
              <li class="refundable"><i class="fa fa-inr"></i> Refundable</li>
              <li class="view_on">
                <a class="flight_details" href="" data-bs-toggle="offcanvas" data-bs-target="#FlightDetails"><i class="fa fa-plane"></i> Flight Details </a>
              </li>
            </ul>
            <p class="required_visa">Dear, Don't need visa : <span>Transant Visa(Visa on Arrival)</span></p>
          </div>
        </div>
      </div>


    </>
  )

};
